/* src/app/timeline-artic/modals/artic-view-order-modal/artic-view-order-modal.component.scss */
/*# sourceMappingURL=artic-view-order-modal.component.css.map */
